/* eslint-disable complexity */
import React, {useContext, useState, useEffect} from 'react';
import {ButtonIcon} from '@homeaway/react-buttons';
import Cookies from 'js-cookie';
import {CLOSE__12, CHEVRON_RIGHT__24, STAR_SELECTED__16} from '@homeaway/svg-defs';
import {SVGIcon} from '@homeaway/react-svg';
import {TrackingContext} from '@homeaway/react-event-tracking';
import * as BannerDefaults from '../banner-defaults';
import * as BannerHelpers from '../utils/bannerHelpers';
import {createCookie, cookieExists, APP_BANNER_COOKIE_NAME} from '../utils/cookies';
import {handleDismissEdapEvent, handleDownloadEdapEvent, handleOnloadEdapEvent} from '../utils/triggerEdapEvent';
import './BannerV2.less';

export const BannerV2 = ({
    ctaLink,
    description,
    rating,
    stars,
    title,
    travelerApp,
    useCanonicalPath
}) => {
    const brandName = BannerHelpers.getBrandName(travelerApp);
    const context = useContext(TrackingContext);
    const site = BannerHelpers.getSite(brandName);
    const imgUrl = BannerHelpers.getImgUrl(site);
    rating = rating || (`${BannerDefaults.RATING} ${BannerDefaults.RATING_TEXT}`);
    stars = parseFloat(stars) || BannerDefaults.STARS;
    title = title || BannerDefaults.TITLE.replace('brand', brandName);
    description = description || BannerDefaults.DESCRIPTION;

    const [showBannerState, setShowBannerState] = useState(null);
    const [bannerPresented, setBannerPresented] = useState(null);
    const [bannerSelected, setBannerSelected] = useState(null);
    const [bannerDismissed, setBannerDismissed] = useState(null);
    const [link, setLink] = useState(BannerHelpers.getDownloadLink(ctaLink, brandName, Cookies.get('hav'), Cookies.get('xdid')));
    const [path, setPath] = typeof window !== 'undefined' ? useState(window.location) : '';

    useEffect(() => {
        if (useCanonicalPath && typeof window !== 'undefined') {
            setPath(window.location);
        }
    }, [path]);

    useEffect(() => {
        if (cookieExists(APP_BANNER_COOKIE_NAME) || bannerSelected || bannerDismissed) {
            setShowBannerState(false);
        } else {
            setShowBannerState(true);
            if (!bannerPresented) {
                handleOnloadEdapEvent(context, BannerDefaults.BANNER);
            }
            setBannerPresented(true);
        }
    });

    function handleCloseButtonClick(element) {
        setBannerDismissed(true);
        handleDismissEdapEvent(context, BannerDefaults.BANNER);
        createCookie();
        element.stopPropagation();
    }

    function handleDownloadButtonClick(element) {
        setBannerSelected(true);
        handleDownloadEdapEvent(context, BannerDefaults.BANNER);
        if (useCanonicalPath) {
            setLink(`${link}&$canonical_url=${path}`);
        }
        createCookie();
        element.stopPropagation();
    }

    return (
        <div className="download-banner-box">
            { showBannerState &&
                <div className="download-banner-box__container"
                    onClick={handleDownloadButtonClick}
                    onKeyDown={handleDownloadButtonClick}
                    role="button"
                    tabIndex={0}
                >
                    <div className="download-banner-box__close">
                        <ButtonIcon label="close-button" noBorder size="xs"
                            svgMarkup={CLOSE__12} onClick={handleCloseButtonClick}
                            data-testid="download-banner-close-button"
                        />
                    </div>
                    <div className="download-banner-box__app-icon">
                        <img src={imgUrl} alt={`${brandName} Logo`} width="54px" height="54px" />
                    </div>
                    <div className="download-banner-box__content">
                        <p><strong>{title}</strong></p>
                        <p className="download-banner-box__description">{description}</p>
                        <div className="download-banner-box__rating">
                            <SVGIcon markup={STAR_SELECTED__16} />
                            <p className="star-and-ratings">{stars} {`(${rating})`}</p>
                        </div>
                    </div>
                    <div className="download-banner-box__submit">
                        <ButtonIcon label="app-icon" noBorder size="xs"
                            className="download-banner__download-button"
                            data-testid="download-banner-download-button"
                            href={link}
                            onClick={handleDownloadButtonClick}
                            svgMarkup={CHEVRON_RIGHT__24}
                        />
                    </div>
                </div>
            }
        </div>
    );
};
